import { render } from "./CheckBoxCompras.vue?vue&type=template&id=2e4dd912&scoped=true"
import script from "./CheckBoxCompras.vue?vue&type=script&lang=js"
export * from "./CheckBoxCompras.vue?vue&type=script&lang=js"

import "./CheckBoxCompras.vue?vue&type=style&index=0&id=2e4dd912&scoped=true&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4dd912"]])

export default __exports__